'use client';

import { useEffect, useState } from 'react';

/**
 * Custom hook to check if a component is mounted after SSR.
 * @returns `true` if the component is mounted, `false` otherwise.
 */
export function useIsMounted(): boolean {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    /* eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect
    -- This hook indicates that the component opts into some client-side only rendering behavior,
    and so this effect runs only once after the component mounts. */
    setIsMounted(true);
  }, []);

  return isMounted;
}
